module.exports = __webpack_public_path__ + "img/menu_car_new.d445419c.png";